import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

const marketingAgentSplitHistoryEntrySchema_ = z.object({
  splitId: z.string(),
  isActive: z.boolean(),
  startDate: zExt.instant(),
  endDate: zExt.instant().nullable(),
  variantTrafficPercentage: z.number().min(0).max(100),
  cooldownHours: z.number().nullable(),
  minPercentage: z.number().nullable(),
  maxPercentage: z.number().nullable(),
});
export const marketingAgentSplitHistoryEntrySchema: z.ZodType<MarketingAgentSplitHistoryEntry> =
  marketingAgentSplitHistoryEntrySchema_;
export interface MarketingAgentSplitHistoryEntry
  extends z.infer<typeof marketingAgentSplitHistoryEntrySchema_> {}

export const getMarketingAgentSplitHistory = {
  name: "getMarketingAgentSplitHistory" as const,
  input: z.object({}),
  output: z.array(marketingAgentSplitHistoryEntrySchema),
};
